import axios from 'axios';

const getBankDataApi = async (token, langIsoCode) => {
  try {
    const url = '/Auth_private/getBankAccount';
    const res = await axios.get(url, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        lang: langIsoCode
      }
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export default getBankDataApi;
